export default __webpack_public_path__ + "static/media/dragger.e039ecce.svg";